export const CONSENT_VERSION = "1.0.0";
export const CONSENT_STORAGE_KEY_PREFIX = "cookieConsent";

// Generate client-scoped consent storage key
export const getConsentStorageKey = (clientId: string | null): string => {
  if (!clientId) {
    // Fallback for when client context is not available yet
    return CONSENT_STORAGE_KEY_PREFIX;
  }
  return `${CONSENT_STORAGE_KEY_PREFIX}_${clientId}`;
};

export type CookieConsent = {
  version: string;
  choices: {
    essential: true;
    analytics: boolean;
    product_improvement: boolean;
    marketing?: boolean;
  };
  timestamp: string;
  locale: "fr" | "en";
};

export const DEFAULT_CONSENT: CookieConsent = {
  version: CONSENT_VERSION,
  choices: {
    essential: true,
    analytics: false,
    product_improvement: false,
    marketing: false,
  },
  timestamp: new Date().toISOString(),
  locale: "fr",
};

export const translations = {
  fr: {
    banner: {
      title: "Nous respectons ta vie privée",
      description: "Nous utilisons des cookies pour faire fonctionner le site, mesurer l'audience et améliorer l'expérience. Tu peux accepter, refuser ou personnaliser tes choix.",
      acceptAll: "Accepter tout",
      rejectAll: "Refuser tout",
      customize: "Personnaliser",
    },
    modal: {
      title: "Paramètres de confidentialité",
      categories: {
        essential: {
          name: "Essentiels",
          description: "Indispensables au fonctionnement (sécurité, session, préférence).",
        },
        analytics: {
          name: "Mesure d'audience",
          description: "Aide à comprendre l'usage du site pour l'améliorer.",
        },
        product_improvement: {
          name: "Amélioration produit",
          description: "Diagnostic, qualité et expérience (A/B, stabilité).",
        },
        marketing: {
          name: "Marketing",
          description: "Contenus et offres personnalisés.",
        },
      },
      save: "Enregistrer",
      acceptAll: "Tout accepter",
      rejectAll: "Tout refuser",
      privacyPolicy: "Politique de confidentialité",
      cookiePolicy: "Politique Cookies",
      successToast: "Préférences enregistrées",
    },
    settings: {
      link: "Paramètres de confidentialité",
    },
  },
  en: {
    banner: {
      title: "We respect your privacy",
      description: "We use cookies to make the site work, measure audience and improve experience. You can accept, reject or customize your choices.",
      acceptAll: "Accept all",
      rejectAll: "Reject all",
      customize: "Customize",
    },
    modal: {
      title: "Privacy settings",
      categories: {
        essential: {
          name: "Essential",
          description: "Necessary for operation (security, session, preferences).",
        },
        analytics: {
          name: "Analytics",
          description: "Helps understand site usage for improvement.",
        },
        product_improvement: {
          name: "Product improvement",
          description: "Diagnostics, quality and experience (A/B, stability).",
        },
        marketing: {
          name: "Marketing",
          description: "Personalized content and offers.",
        },
      },
      save: "Save",
      acceptAll: "Accept all",
      rejectAll: "Reject all",
      privacyPolicy: "Privacy Policy",
      cookiePolicy: "Cookie Policy",
      successToast: "Preferences saved",
    },
    settings: {
      link: "Privacy settings",
    },
  },
};
